function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.024 2a5.044 5.044 0 00-5.027 5.432l.243 3.158a4.89 4.89 0 00.577 1.96c-.804.358-1.895.877-3.026 1.493-1.06.577-1.816 1.657-1.858 2.937-.049 1.51.06 3.793.646 6.428a1.008 1.008 0 101.968-.438c-.544-2.453-.642-4.565-.598-5.925.016-.493.308-.959.805-1.23a40.656 40.656 0 013.448-1.666c.818.61 1.832.968 2.924.968a4.881 4.881 0 002.924-.969c.618.26 1.652.727 2.79 1.318a8.06 8.06 0 012.854-.334 3.646 3.646 0 00-1.233-1.09 43.717 43.717 0 00-3.026-1.492c.32-.589.522-1.252.577-1.96l.243-3.158A5.044 5.044 0 0014.227 2h-.203zm.203 2.018h-.203a3.026 3.026 0 00-3.016 3.26l.243 3.157a2.884 2.884 0 005.75 0l.243-3.158a3.026 3.026 0 00-3.017-3.259z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.589 20.515a.757.757 0 00-1.07 1.07l1.604 1.604-1.604 1.604a.757.757 0 001.07 1.07l1.604-1.604 1.604 1.604a.757.757 0 001.07-1.07l-1.604-1.604 1.604-1.604a.757.757 0 00-1.07-1.07l-1.604 1.604-1.604-1.604z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.386 23.19a6.809 6.809 0 016.807-6.812c3.76 0 6.807 3.05 6.807 6.811A6.809 6.809 0 0122.193 30a6.809 6.809 0 01-6.807-6.81zm6.807-5.298a5.296 5.296 0 00-5.294 5.297 5.296 5.296 0 005.294 5.297 5.296 5.296 0 005.294-5.297 5.296 5.296 0 00-5.294-5.297z",
  fill: "currentColor"
})));